<script setup lang="ts">
import { defineProps } from 'vue';
import { VueEternalLoading } from '@ts-pro/vue-eternal-loading';
import UploadCard from '../UploadCard.vue';
import DraftCard from '../DraftCard/DraftCard.vue';
import { useDraftsList } from '@/dashboard/vue/components/drafts/DraftsList/useDraftsList';
import LeavedUserCard from '@/dashboard/vue/components/drafts/LeavedUserCard.vue';
import { GroupMoveItems } from '@/dashboard/vue/components/public/PublicMainDraft/usePublicMainDraft';

const props = defineProps<{
  groupMoveItems: GroupMoveItems[];
}>();

const {
  canUpload,
  mobileColumns,
  draftsFiltered,
  uploading,
  uploadingProgress,
  projectShortLink,
  uploadedFilesCount,
  allFilesCount,
  addChecked,
  deleteDraft,
  moveDraft,
  loadData,
  isChecked,
  canDeleteDraft,
  canMoveDraft,
  startUpload,
} = useDraftsList();
</script>

<template>
  <transition-group
    tag="div"
    name="draft"
    class="mt-l grid gap-s max-tablet:gap-[9px] laptop:grid-cols-4 laptop:px-s desktop:grid-cols-6 large-desktop:grid-cols-8"
    :class="{ 'mob-columns grid-cols-2': mobileColumns, 'grid-cols-1': !mobileColumns }"
  >
    <div v-if="canUpload" class="laptop:col-span-1" :class="{ 'col-span-2': mobileColumns }">
      <UploadCard
        :progress="uploadingProgress"
        :all-count="allFilesCount"
        :uploaded-count="uploadedFilesCount"
        :uploading="uploading"
        :start-upload="startUpload"
      />
    </div>

    <div v-if="false">
      <LeavedUserCard />
    </div>

    <div v-for="item in draftsFiltered" :key="item.id">
      <DraftCard
        v-if="item"
        :draft="item"
        :group-move-items="groupMoveItems"
        :can-delete="canDeleteDraft(item)"
        :can-move="canMoveDraft(item)"
        :mobile-columns="mobileColumns"
        :checked="isChecked(item)"
        :check-action="addChecked"
        :delete-action="deleteDraft"
        :move-action="moveDraft"
      />
    </div>

    <VueEternalLoading :key="projectShortLink" :load="loadData" :margin="'100px'">
      <template #loading><span></span></template>
      <template #no-more><span></span></template>
      <template #no-results><span></span></template>
      <template #error><span></span></template>
    </VueEternalLoading>
  </transition-group>
</template>

<style lang="scss" scoped>
.draft-enter-active {
  transition: opacity 0.5s ease;
}

.draft-enter-from {
  opacity: 0;
}

.draft-enter-to {
  opacity: 1;
}
</style>
